import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=5edbffca&scoped=true&"
import script from "./CreateCourse.vue?vue&type=script&lang=js&"
export * from "./CreateCourse.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourse.vue?vue&type=style&index=0&id=5edbffca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbffca",
  null
  
)

export default component.exports